export const es = {
    PrivacyPolicy: "Política de privacidad",
    PrivacyPolicyTitle: "Política de privacidad",
    Close: "Cerrar",
    ClearReadNotifications: "Borrar notificaciones leídas",
    ContactUs: "Contáctanos",
    NewsletterInvalidEmail: "Email no válido.",
    NewsletterSaveFailed: "No se pudo guardar tu email. Inténtalo de nuevo.",
    NewsletterEmailPlaceholder: "Tu email",
    NewsletterCta: "Suscribirse",
    NewsletterSubmitting: "Suscribiendo",
    NewsletterThanks: "¡Gracias! Te has suscrito.",
    SubscriptionCanceledTitle: "Suscripción cancelada",
    SubscriptionCanceledMessage:
      "Tu suscripción ha sido cancelada. Puedes renovarla en cualquier momento.",
    RenewSubscription: "Renovar suscripción",
    AllSubscriptions: "Todas las suscripciones",
    Subscription: "Suscripción",
    Customer: "Cliente",
    Price: "Precio",
    CancelScheduled: "Cancelación programada",
    ConfirmCancelSubscription:
      "¿Confirmas la cancelación de esta suscripción al final del periodo?",
    CancelNow: "Cancelar al final del periodo",
    PaymentSuccessMessage: "Tu suscripción Premium ya está activa.",
    GoToDashboard: "Ir al panel",
    PaymentCanceledTitle: "Pago cancelado",
    PaymentCanceledMessage:
      "El pago fue cancelado. Puedes intentarlo de nuevo.",
    TryAgain: "Reintentar",
    ManageSubscription: "Gestionar suscripción",
    DarkModeOn: "Modo oscuro activado",
    DarkModeOff: "Modo oscuro desactivado",
    PremiumNeededForMoreProjects:
      "El plan Gratis permite solo un proyecto. Pasa a Premium para crear más.",
    Limit3CollaboratorsNonPremium:
      "No puedes añadir más de 3 usuarios por proyecto si no eres Premium.",
    Limit3CollaboratorsReachedInvite:
      "Alcanzaste el límite gratuito de {limit} colaboradores. Pasa a Premium para invitar más.",
    MonthlyTicketCapReached:
      "Alcanzaste el límite mensual de {limit} tickets en el plan Gratis. Pasa a Premium para seguir creando.",
    FreePlanProjectLimit: "En el plan Gratis solo puedes crear un proyecto.",
    ProjectLimitReached:
      "Límite de proyectos alcanzado. Pasa a Premium para crear más.",
    FreePlanTicketLimit:
      "En el plan Gratis puedes crear hasta 40 tickets al mes.",
    TicketLimitReached:
      "Límite mensual de tickets alcanzado (40). Pasa a Premium para tickets ilimitados.",
    CurrentMonthTicketsCount: "Tickets creados este mes: {count}/40.",
    OnlyOneProjectOnFree: "Solo se permite un proyecto en el plan Gratis.",
    FortyTicketsPerMonthOnFree:
      "Límite de 40 tickets por mes en el plan Gratis.",
    MyTickets: "Mis tickets",
    SearchTicketsPlaceholder: "Buscar tickets (título, descripción, nº)",
    YouArePremium: "Eres Premium",
    PaymentSuccessTitle: "Pago exitoso",
    GoPremium: "Pasar a Premium",
    HelpFAQs: "Ayuda y FAQs",
    TicketInsights: "Ticket Insights",
    Dashboard: "Estadísticas",
    AvailableOnPremium: "Disponible en Premium",
    DetailAvailableOnPremium: "Accede a más funciones pasando al plan Premium",
    DetailComingSoon: "Estamos trabajando en ello",
    ComingSoon: "En construcción",
    Brand: "Ticketize",
    NavOffer: "Nuestra oferta",
    Pricing: "Precios",
    SignIn: "Iniciar sesión",
    PricingPageTitle:
      "Precios Ticketize - Tickets gratis, 5 €/mes para escalar",
    PricingPageMeta:
      "Oferta gratis para equipos pequeños, 5 €/mes para tickets, agentes y alertas ilimitados. Ticketize es el SaaS de tickets más económico.",
    PricingTitle: "Nuestras ofertas",
    PricingSubtitle: "Empieza gratis, sube de nivel si lo necesitas.",
    TierFreeName: "Gratis",
    TierFreePrice: "0",
    TierFreeFeature1: "Hasta 50 tickets/mes",
    TierFreeFeature2: "3 usuarios activos",
    TierFreeFeature3: "Notificaciones in-app",
    TierFreeFeature4: "100 MB de adjuntos",
    TierFreeButton: "Empezar",
    TierPremiumName: "Premium",
    TierPremiumPrice: "5",
    TierPremiumFeature1: "Tickets y usuarios ilimitados",
    TierPremiumFeature2: "Notificaciones por email y SMS",
    TierPremiumFeature3: "Insights IA semanales",
    TierPremiumFeature4: "Webhooks y SSO",
    TierPremiumFeature5: "Branding propio y soporte prioritario",
    TierPremiumButton: "Pasar a Premium",
    AboutPageTitle: "Sobre Ticketize - Sostenible",
    AboutPageMeta:
      "Descubre cómo Ticketize sigue siendo rentable: plan gratis generoso a coste 0$, y un Premium a 5$/mes que financia alertas email/SMS y análisis IA.",
    AboutHeroTitle: "¿Quiénes somos?",
    AboutHeroSubtitle:
      "En Ticketize, nuestra misión es ofrecer a las pequeñas empresas un sistema de tickets completo — gratis hasta 50 tickets/mes, sin publicidad.",
    AboutModelTitle: "Nuestro modelo sostenible",
    FreePlanTitle: "Plan Gratis",
    FreePlanFeature1:
      "Hasta 50 tickets/mes — suficiente para la mayoría de pymes.",
    FreePlanFeature2:
      "Sin banners, sin trucos — solo un servicio simple y fiable.",
    PremiumPlanTitle: "Plan Premium",
    PremiumPlanFeature1: "5$/mes para tickets y usuarios ilimitados.",
    PremiumPlanFeature2: "Notificaciones email y SMS para estar al día.",
    PremiumPlanFeature3:
      "Análisis IA semanales: tus problemas recurrentes identificados automáticamente.",
    WhyChooseTitle: "¿Por qué elegir Ticketize?",
    WhyChooseFeature1Title: "Inicio a coste cero",
    WhyChooseFeature1Desc:
      "Cientos de empresas onboarded sin gastar un céntimo.",
    WhyChooseFeature2Title: "Premium escalable",
    WhyChooseFeature2Desc:
      "Un plan generoso a 5$/mes que se adapta a tus necesidades.",
    WhyChooseFeature3Title: "Insights IA automatizados",
    WhyChooseFeature3Desc:
      "Informes semanales para detectar incidencias recurrentes.",
    HeroTitlePart1: "El SaaS de tickets más simple",
    HeroTitlePart2: "gratis para equipos pequeños",
    HeroHighlight: "Ticketize",
    HeroTitleFull:
      "Ticketize - El SaaS de tickets más simple, gratis para equipos pequeños",
    HeroMetaDescription:
      "Ticketize es el SaaS de tickets más simple: gratis para equipos pequeños, el coste más bajo para escalar, flujos limpios, agentes ilimitados a 5€/mes.",
    HeroSubtitle:
      "Centraliza las solicitudes, asigna y resuelve más rápido. Empieza gratis; agentes ilimitados a 5€/mes.",
    HeroPrimaryCta: "Crear mi cuenta gratis",
    HeroPrimaryCtaHelper: "Tu cuenta de Google basta para empezar en minutos.",
    EmailPlaceholder: "Tu email",
    ButtonDemo: "Pedir una demo",
    HeroImageAlt: "Vista previa del panel Ticketize",
    FeatureZeroCost: "Funciones gratis y sin anuncios",
    FeatureEase: "Implementación y uso simplificados",
    FeaturePremiumValue: "Premium a 5$/mes con insights IA",
    DeleteTicket: "Eliminar el ticket",
    ConfirmDeleteTicket: "¿Seguro que quieres eliminar el ticket?",
    EditPicture: "Modificar la foto",
    Welcome: "Bienvenido",
    WhoAreWe: "¿Quiénes somos?",
    All: "Todos",
    AdminNoProjectsYet: "Ningún proyecto por ahora",
    NoProjectSelected: "Ningún proyecto seleccionado",
    GetStartedByCreatingProject: "Empieza creando un proyecto",
    TicketAddedSuccessfully: "Ticket añadido con éxito",
    FailedToAddTicket: "Fallo al añadir el ticket",
    TicketUpdatedSuccessfully: "Ticket actualizado con éxito",
    FailedToUpdateTicket: "Fallo al actualizar el ticket",
    OnlyCreatorCanEdit: "Solo el creador o un admin puede editar este ticket",
    AttachmentsSaved: "Adjuntos guardados",
    SelectProject: "Selecciona un proyecto",
    MustBeActiveUser: "Debes ser un usuario activo para realizar esta acción",
    PriorityError: "Prioridad",
    InvalidEmail: "Introduce un email válido",
    EmailAlreadyInvited: "Este email ya ha sido invitado",
    AlreadyMemberOfACompany: "Este usuario ya pertenece a una empresa",
    InviteFailed: "Fallo al enviar la invitación",
    RoleUpdated: "Rol actualizado con éxito",
    RoleUpdateFailed: "Fallo al actualizar el rol",
    PhotoUploadFailed: "Fallo al subir la foto",
    UserDeletedSuccessfully: "Usuario eliminado con éxito",
    UserDeleteFailed: "Fallo al eliminar el usuario",
    ProjectUpdated: "Proyecto actualizado con éxito",
    ProjectDeletedConfirm: "¿Seguro que quieres eliminar este proyecto?",
    Logout: "Cerrar sesión",
    ConfirmLogout: "¿Confirmar cierre de sesión?",
    NoMemberToAdd: "Puedes añadir un miembro (opcional).",
    OptionalMemberInfo: "Puedes añadir un miembro (opcional).",
    ExplainationAddProject:
      "Introduce un nombre de proyecto y los usuarios que quieras asociar a él",
    NoProjects: "Ningún proyecto creado por ahora",
    InviteSent: "Invitación enviada",
    AttachedFiles: "ARCHIVO(S) ADJUNTO(S)",
    SendAMessage: "Enviar un mensaje",
    InviteByEmail: "Invitar un usuario por email",
    EmailAddress: "Dirección de email",
    NoTicketsInTabMessage: "Selecciona otra pestaña para ver si hay tickets",
    NoTicketsInTab: "No hay tickets en este estado para este proyecto",
    TryAnotherProjectOrTab:
      "Selecciona/añade un proyecto arriba o cambia de pestaña",
    ChooseAProject: "Elige un proyecto",
    SaveAttachments: "Actualizar",
    Done: "Terminado",
    MaxFileSize: "Tamaño máx. de archivo: ",
    DragAndDropOrBrowse: "Arrastra y suelta o selecciona un archivo",
    UploadFiles: "Subir archivo(s)",
    ManageFile: "Añadir/quitar archivo(s)",
    Closed: "Cerrado",
    InReview: "En revisión",
    InTest: "En test",
    InProduction: "En producción",
    InStaging: "En preproducción",
    UserComment: "Comentario usuario",
    Open: "Abierto",
    WorkingOnIt: "En curso",
    StatusChangedOpen: "Estado: Abierto",
    StatusChangedClosed: "Estado: Cerrado",
    TicketCreated: "Ticket creado",
    AdminComment: "Comentario admin",
    PriorityChanged: "Prioridad modificada",
    TicketActivity: "Actividad del ticket",
    NoActivityYet: "Aún no hay actividad",
    AddComment: "Añadir un comentario",
    PostComment: "Publicar comentario",
    Incident: "Incidente",
    Problem: "Problema",
    Question: "Pregunta",
    Suggestion: "Sugerencia",
    Evolution: "Evolución",
    Bug: "Bug",
    Feature: "Funcionalidad",
    Improvement: "Mejora",
    ChangeRequest: "Solicitud de cambio",
    Task: "Tarea",
    Low: "Baja",
    Medium: "Media",
    High: "Alta",
    PriorityForm: "Prioridad",
    TicketNameForm: "Nombre del ticket",
    RequiredField: "Campo obligatorio",
    TicketTypeError: "Tipo de ticket",
    WriteDescriptionError: "Descripción del ticket",
    TicketNameError: "Nombre del ticket",
    MissingFields: "CAMPOS FALTANTES",
    Type: "TIPO",
    Project: "PROYECTO",
    Creator: "CREADO POR",
    Save: "Guardar",
    OptionalMessage: "Mensaje (opcional)",
    SelectMembers: "Selecciona miembros",
    ProjectMembers: "Miembros del proyecto",
    EditProject: "Editar proyecto",
    ProjectCreated: "Proyecto creado",
    Create: "Crear",
    CommaSeparated: "Separado por comas",
    PageListCategories: "Lista de tipos de páginas",
    ProjectName: "Nombre del proyecto",
    AddProject: "Añadir un proyecto",
    ContactAdminsAt: "Contacta al administrador en ",
    YouAreSuspended: "Tu cuenta ha sido suspendida",
    OnboardingTitle: "Unas preguntas rapidas",
    OnboardingSubtitle:
      "Esto nos ayuda a mejorar Ticketize desde el lanzamiento.",
    OnboardingBack: "Atras",
    OnboardingNext: "Continuar",
    OnboardingFinish: "Finalizar",
    OnboardingStepLabel: "Paso",
    OnboardingQuestionAcquisition: "Como nos encontraste?",
    OnboardingQuestionUsage:
      "Para que tipo de uso vas a usar Ticketize?",
    OnboardingQuestionIndustry: "En que sector estas?",
    OnboardingOptionGoogle: "Google",
    OnboardingOptionChatgpt: "ChatGPT",
    OnboardingOptionReddit: "Reddit o similar",
    OnboardingOptionOther: "Otro",
    OnboardingOptionPro: "Uso profesional",
    OnboardingOptionPersonal: "Uso personal",
    OnboardingOptionTech: "Tech / SaaS / Agencia digital",
    OnboardingOptionEcommerce:
      "E-commerce / Retail / Servicios online",
    OnboardingOptionLocal: "Servicios locales / PyME",
    OnboardingOptionOtherIndustry: "Otro sector",
    AddAProject: "Añadir un proyecto",
    ProjectsList: "LISTA DE PROYECTOS",
    Pending: "Pendiente",
    TeamMembers: "MIEMBRO(S) DEL EQUIPO",
    JoinedOn: "Inscrito el",
    SendInvite: "Enviar invitación",
    EmailAlreadyExists: "Ya se envió una invitación a este email",
    ProfileFormDescription:
      "Por favor, indica el nombre de tu empresa para asociarte a ti y a tu equipo a esta entidad",
    NoColleagues: "Nadie de tu equipo por el momento",
    Company: "Empresa",
    PleaseFillYourCompanyName: "Introduce el nombre de tu empresa",
    CompleteYourProfile: "¿Cuál es el nombre de tu empresa?",
    PleaseFillYourCompanyNameFirst: "Primero introduce el nombre de tu empresa",
    Confirm: "Confirmar",
    InviteUser: "Invita a un usuario",
    YourUserProfil: "Tu perfil de usuario",
    UserProfile: "Perfil de usuario",
    YourColleagues: "Miembros del equipo",
    NoTicketsToShow:
      "Sin tickets para este proyecto / Ningún proyecto seleccionado",
    NoProjectNormal: "Ningún proyecto por ahora",
    Projects: "Proyectos",
    SuccessfullyLoggedInWithGoogle: "Sesión iniciada con Google",
    Signout: "Cerrar sesión",
    UpdateTicket: "Actualizar ticket",
    performedBy: "Gestionado por:",
    Deleting: "Eliminando...",
    AreYouSureToDeleteTicket: "¿Seguro que quieres eliminar este ticket?",
    ErrorDeletingTicket: "Problema al eliminar el ticket:",
    TicketSuccessfullyDeleted: "Ticket eliminado con éxito",
    Delete: "Eliminar",
    Edit: "Editar",
    Cancel: "Cancelar",
    TicketType: "TIPO DE TICKET",
    WriteDescription: "DESCRIPCIÓN DEL PROBLEMA",
    Reset: "Reiniciar",
    CreatedAt: "CREADO EL",
    Status: "ESTADO",
    PageConcerned: "ELEMENTO AFECTADO",
    Priority: "PRIORIDAD",
    TicketName: "NOMBRE DEL TICKET",
    TicketNumber: "# TICKET ",
    Select: "Selecciona",
    LatestSupportTickets: "Últimos tickets publicados",
    AddNewTicket: "Añadir un ticket",
    PleaseSendTicket: "Envía un ticket, por favor",
    SupportTickets: "Tickets de soporte",
    WelcomeToTicketHub: "Bienvenido a Ticketize",
    LogInWithGoogle: "Inicia sesión con Google",
};
